<template>
  <Modal v-model="platformSelfOperatedProductModel" :title="$t('key1001831')" width="700" :transfer="false"
    :mask-closable="false" @on-visible-change="platformSelfOperatedProductChange">
    <p class="red-dot mb5">{{ $t('key1002237') }}</p>
    <div class="flex align-items-center pl12 mb30">
      <span>{{ $t('key1002238') }}</span>
      <Select v-model="settlementPeriodType" class="width_90 ml8 mr8">
        <Option v-for="item in settlementPeriodTypeList" :value="item.value" :key="item.value">{{ item.name }}</Option>
      </Select>
      <p>{{ $t('key1002235') + billTypeName + $t('key1002236') }}</p>
      <InputNumber
        :min="1"
        :max="billMaxValue"
        v-model="settlementPeriodValue"
        :formatter="value => `${parseInt(value)}`"
        class="width_90 ml8 mr8">
      </InputNumber>
      <span>{{ $t('key1002239') }}</span>
    </div>
    <template #footer>
      <Button @click="platformSelfOperatedProductModel = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="platformSelfOperatedProductBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import {saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: 'platformSelfOperatedProductModel',
  mixins: [Mixin],
  data() {
    return {
      platformSelfOperatedProductModel: false,
      settlementPeriodType: 1,
      settlementPeriodValue: 1,
      configParamKey: null,
      settlementPeriodTypeList: [
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002228')},
        {value: 2, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002229')},
        {value: 3, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002230')},
      ]
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 获取账单最大值
    billMaxValue() {
      let maxValue = 30;
      switch (this.settlementPeriodType) {
        case 1:
          maxValue = 30;
          break;
        case 2:
          maxValue = 15;
          break;
        case 3:
          maxValue = 7;
          break;
      }
      return maxValue;
    },
    // 获取账单类型名称
    billTypeName() {
      let billTypeName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002231');
      switch (this.settlementPeriodType) {
        case 1:
          billTypeName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002231');
          break;
        case 2:
          billTypeName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002232');
          break;
        case 3:
          billTypeName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002233');
          break;
      }
      return billTypeName;
    }
  },
  methods: {
    // 初始化数据
    iniPlatformSelfOperatedProductData(paramKey, obj) {
      if (obj) {
        this.settlementPeriodType = obj.settlementPeriodType;
        this.settlementPeriodValue = obj.settlementPeriodValue;
      }
      this.configParamKey = paramKey;
      this.platformSelfOperatedProductModel = true;

    },
    // 监听弹窗
    platformSelfOperatedProductChange(val) {
      if (!val) {
        this.settlementPeriodType = 1;
        this.settlementPeriodValue = 1;
        this.configParamKey = null;
        this.platformSelfOperatedProductModel = false;
      }
    },
    // 确定按钮
    platformSelfOperatedProductBtn() {
      if (!this.settlementPeriodValue) {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002234'));
        return false;
      }
      let obj = {
        settlementPeriodType: this.settlementPeriodType,
        settlementPeriodValue: this.settlementPeriodValue,
      }
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: this.configParamKey,
          paramValue: JSON.stringify(obj),
        }
      ];
      saveErpCommonSettingParam(queryList).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
        this.platformSelfOperatedProductModel = false;
        this.$emit('updateConfigData', true);
      });
    }
  }
};
</script>

<style lang="less">

</style>
